module.exports = __webpack_public_path__ + "img/bg_chart.1f568fbb.png";